import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { registerUser } from 'modules/auth/actions'
import { Link } from 'react-router-dom'
import _map from 'lodash/mapValues'
import { SIGN_IN_PATH, subscriptionPlans } from 'config'
import AuthAlerts from 'components/auth/auth-alerts'


export class Register extends Component {
  static propTypes = {
    registerUser: PropTypes.func.isRequired,
  }

  state = { email: '', password: '', name: '', planId: Object.keys(subscriptionPlans)[0] }

  submitHandler = event => {
    event.preventDefault()
    this.props.registerUser(this.state)
  }

  inputChangeHandler = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    const { email, password, name, planId } = this.state

    return (
      <div className="center-block auth-form__container auth-form__container--register">
        <div className="auth-form">
          <AuthAlerts />
          <div className="card card-block mb-3">
            <form
              onSubmit={ this.submitHandler }
              role="form" noValidate>
              <h2>Register</h2>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Name"
                  name="name"
                  type="text"
                  value={ name }
                  required
                  onChange={ this.inputChangeHandler }
                />
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Email"
                  name="email"
                  type="email"
                  value={ email }
                  required
                  onChange={ this.inputChangeHandler }
                />
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Password"
                  name="password"
                  type="password"
                  value={ password }
                  required
                  onChange={ this.inputChangeHandler }
                />
              </div>
              <hr />
              <div className="form-group">
                <select
                  className="form-control"
                  name="planId"
                  value={planId}
                  onChange={ this.inputChangeHandler } >
                  { Object.values(_map(subscriptionPlans, (plan, planId) => {
                    return (<option key={planId} value={planId}>
                      {plan.title} plan ({ plan.price > 0 ? `$${plan.price}/month` : 'free' })
                    </option>)
                  })) }
                </select>
              </div>
              <button className="btn btn-primary" type="submit">Register</button>
            </form>
          </div>
          <p>Already have an account? <Link to={ SIGN_IN_PATH }>Sign in</Link></p>
        </div>
      </div>
    )
  }
}

export default connect(null, { registerUser })(Register)



// WEBPACK FOOTER //
// ./src/components/auth/register/register.js